// Module
var code = "<template> <require from=\"app/cm/components/audit-log/case-audit-log\"></require> <compose view-model=\"app/cm/components/audit-log/case-audit-log\" model.bind=\"modelData\"></compose> </template> ";
// Exports
module.exports = code;